import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { Content } from '../BodyStep/styles';
import Button from '../Button';
import {
  BadgeResult,
  MessageError,
  ProfileContent,
  ProfileData,
  ResultContent,
} from './styels';

const Result: React.FC = () => {
  const {
    imageDoc,
    name,
    documentNum,
    clearData,
    result,
    messageError,
    setMessageError,
    handleReturnCurrentStep,
    serviceError,
  } = useSteps();

  const handleTryAgain = () => {
    handleReturnCurrentStep();
    setMessageError('');
  };

  return (
    <Content>
      {serviceError && <BadgeResult>{serviceError}</BadgeResult>}
      <Title>Resultado</Title>
      <ProfileContent>
        {!isMobileOnly && <img src={imageDoc} alt="" />}
        <ProfileData>
          {name && (
            <>
              <p>Nome Completo</p>
              <span>{name}</span>{' '}
            </>
          )}
          <p>Documento</p>
          <span>{documentNum}</span>
          <ResultContent mode={result}>
            {result === 'success' && (
              <p>
                <FaCheck size={24} color="#fff" />
                APROVADO
              </p>
            )}
            {result === 'error' && (
              <p>
                <FaTimes size={24} color="#fff" />
                REPROVADO
              </p>
            )}
            {result === 'warn' && (
              <p>
                <FaTimes size={24} color="#fff" />
                FALHA
              </p>
            )}
          </ResultContent>
        </ProfileData>
      </ProfileContent>
      <MessageError>{result === 'warn' && messageError}</MessageError>
      <Button
        title={result === 'warn' ? 'Tirar nova foto' : 'Voltar ao Início'}
        onClick={result === 'warn' ? handleTryAgain : clearData}
      />
    </Content>
  );
};

export default Result;
